<template>
<section class="notice_view">
    <div class="wrap">
        <div class="notice_view_info">
            <p></p>
            <span>2021-10-01</span>
        </div>
    </div>

    <div class="notice_contents">
        (주)그리트라운지 (이하 “회사”)는 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 “정보통신망법”), 개인정보보호법, 통신비밀보호법, 전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보 보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 “회원”의 권익 보호에 최선을 다하고 있습니다. “회사”는 “회원”의 개인정보를 보호하고 개인정보와 관련한 “회원”의 고충을 원활하게 처리할 수 있도록 개인정보처리방침을 제정•시행하며, 개인정보처리방침을 개정하는 경우 “회사”가 제공•운영하는 웹사이트 및 모바일 어플리케이션(이하 “서비스”)의 공지사항(또는 개별공지)을 통하여 공지합니다.<br>
        
        <br>

        <strong style="font-size:15px;">제1조 개인정보의 수집 및 이용 목적</strong><br><br>
        “회사”는 “회원”의 동의가 있거나 법령의 규정에 의한 경우를 제외하고는 본 조에서 고지한 범위를 넘어 ”회원”의 개인정보를 이용하지 않습니다. 수집한 개인정보의 이용 목적은 아래와 같습니다.<br><br>
        (1) 회원 관리 : 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량 회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 가입 및 가입횟수 제한, 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 연령확인, 불만처리 등 민원 상담 처리, 고지사항 등 최신 정보 전달<br><br>
        (2) “서비스” 제공에 관한 계약 이행 및 요금정산 : 예약, 서비스 요금 결제, 콘텐츠 제공, 물품 배송 또는 청구서 등 발송, 금융거래 본인 인증 및 금융 서비스, 요금추심 등 각종 계약체결 및 이행에 필요한 사항<br><br>
        (3) 맞춤형 회원 서비스 개발 : 신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 개선, 만족도 조사, 인구 통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 이용자의 서비스 이용에 대한 통계 추출, 결제유형 별 할인혜택 서비스 개발 및 제공<br><br>
        (4) 통계작성, 과학적 연구, 공익적 기록보존 등을 위한 가명정보 처리<br><br>
        (5) 마케팅 및 광고 제공(마케팅 정보 수신 동의 시) : 광고, 서비스 안내, 혜택 제공, 리워드 부여, 쿠폰 제공 안내<br>

        <br>

        <strong style="font-size:15px;">제2조 개인정보의 수집 항목 및 방법</strong><br><br>
        (1) 수집하는 개인정보의 항목<br><br>
        “회사”가 수집하는 개인정보의 항목은 “회원”이 “서비스”를 이용하기 위해 필수로 필요한 항목과 “회원”의 선택에 따른 항목이 있습니다.<br><br>
        1. 개인 정보 : 이름, 생년월일, 성별, 내국인여부, 이메일 주소, 통신사, 휴대전화번호, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)<br><br>
        2. 서비스 이용관련 정보 : 예약내역, 결제내역, 위치정보 및 각종 문의사항<br><br>
        (2) 개인정보 수집방법<br>
        “회사”는 다음과 같은 방법으로 개인정보를 수집합니다.<br><br>
        • 서비스를 통한 회원 가입, 하위 부가서비스 신청 및 정보 수집<br>
        • 본인확인 서비스를 통한 수집<br>
        • 유선 또는 온라인 상담 서비스 이용<br>
        • 이벤트 경품 응모, 배송 요청<br>
        • 제휴사로부터의 제공<br>
        • 서비스 이용 과정에서 자동으로 수집<br>
        • 본인•타인의 민원 또는 신고<br>
        
        <br>

        <strong style="font-size:15px;">제3조 개인정보의 보유 및 이용기간</strong><br><br>
        “회사”는 “회원”이 회원자격을 유지하고 있는 동안 수집된 “회원”의 개인정보를 보유•이용할 수 있으며, “회원”이 탈퇴하거나 자격을 상실할 경우에는 “회원”의 별도 요청이 없더라도 수집된 회원정보를 삭제 및 파기합니다. 단, “회원”의 회원탈퇴 또는 회원자격 상실에도 불구하고 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존하며, “회원”의 처리정지, 삭제 요구권의 대상이 되지 아니합니다.<br><br>
        (1) 회사 내부 방침에 의한 정보 보유<br>
        <table class="Terms_table">
            <colgroup>
                <col width="33%">
                <col width="34%">
                <col width="33%">
            </colgroup>
            <thead>
                <tr>
                    <th>보존 근거</th>
                    <th>보존 항목</th>
                    <th>보존 기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>회원 탈퇴 후 재가입 방지 목적</td>
                    <td>암호화된 동일인 식별정보(CI)</td>
                    <td>3개월</td>
                </tr>
                <tr>
                    <td>회원의 악의적 서비스 이용 재발 방지 목적</td>
                    <td>암호화된 동일인 식별정보(CI),<br> 악의적 서비스 이용내역 및 제재 사유, 일자</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>영구정지 회원의 재가입 방지 목적</td>
                    <td>암호화된 동일인 식별정보(CI),<br> 악의적 서비스 이용내역 및 제재 사유, 일자</td>
                    <td>영구</td>
                </tr>
            </tbody>
        </table><br><br>
        (2) 관계법령에 의한 정보 보유<br>
        <table class="Terms_table">
            <colgroup>
                <col width="33%">
                <col width="34%">
                <col width="33%">
            </colgroup>
            <thead>
                <tr>
                    <th>보존 근거</th>
                    <th>보존 항목</th>
                    <th>보존 기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                    <td>
                        계약 또는 청약철회 등에 관한 기록<br> (회원 식별번호, 계약ㆍ청약철회 기록 등)
                    </td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                    <td>대금결제 및 재화 등의 공급에 관한기록</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>전자상거래 등에서의 소비자보호에 과난 법률</td>
                    <td>소비자의 불만 및 분쟁처리에 관한 기록</td>
                    <td>3년</td>
                </tr>
                <tr>
                    <td>
                        신용정보의 이용 및 보호에 관한법률
                    </td>
                    <td>
                        신용정보의 수집ㆍ처리 및 이용 등에 관한 기록
                    </td>
                    <td>3년</td>
                </tr>
                <tr>
                    <td>통신비밀보호법</td>
                    <td>웹 사이트 방문기록(로그기록, IP 등)</td>
                    <td>3개월</td>
                </tr>
            </tbody>
        </table><br><br>
        (3) 휴면회원의 정보 보유<br>
        “회원”이 1년 이상 “서비스”를 이용하지 않고 연체나 채무불이행 상태가 아닌 경우 해당 “회원”은 "휴면회원"으로 처리됩니다. 휴면회원으로 처리되면 회원 로그인을 비롯한 모든 서비스에 대한 이용이 정지되고, “회사”는 휴면회원의 개인정보를 제1항 및 제2항에 따른 정보 보유의 대상이 아닌 한 다른 계정과 별도로 관리합니다. “회사”는 휴면회원 처리 예정일 30일 전 해당 사실을 사전 안내하며, “회원”은 휴면회원 처리일 이후에 “서비스”를 통해 휴면상태 해지신청을 하는 즉시 다시 정상적으로 “서비스”를 이용할 수 있습니다.<br>

        <br>

        <strong style="font-size:15px;">제4조 동의의 거부권 및 거부 시 의 불이익 등</strong><br><br>
        “회원”은 개인정보 수집•이용에 관한 동의를 거부할 권리가 있습니다. 단, 계약 체결 등을 위해 필요한 최소한의 개인정보 수집•이용에 관한 동의를 거부하는 경우에는 “서비스”이용이 불가할 수 있습니다.<br>

        <br>

        <strong style="font-size:15px;">제5조 개인정보의 파기절차 및 방법</strong><br><br>
        “회사”는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령에 따라 개인정보를 보존하여야 하는 경우에는 해당 기간 경과 후 지체없이 재생 불가능한 방법으로 파기하며, “회사”의 개인정보 파기절차 및 방법은 다음과 같습니다.<br><br>
        (1) 개인정보 파기절차<br>
        “회원”이 입력한 정보는 수집 및 이용목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류함) 내부 규정 및 기타 관련 법령에 따라 일정기간 저장되거나 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의해 허용된 경우가 아니고서는 다른 목적으로 이용되지 않습니다.<br><br>
        (2) 개인정보 파기기한<br>
        개인정보의 보유기간이 경과한 경우에는 그 경과한 날로부터, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 된 경우에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 각 지체 없이(정당한 사유가 없는 한 영업일 기준 5일 이내) 해당 개인정보를 파기합니다.<br><br>
        (3) 개인정보 파기방법<br>
        전자적 파일 형태의 정보는 로우레벨포맷, 와이핑 방법 등 복구 및 재생이 되지 않는 기술적인 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.<br>

        <br>

        <strong style="font-size:15px;">제6조 회원의 권리와 그 행사방법</strong><br><br>
        (1) “회원”은 언제든지 등록되어 있는 자신의 개인정보를 열람하거나 수정할 수 있으며, 개인정보에 대한 열람을 “회사”에 요청할 수 있습니다.<br><br>
        (2) “회원”은 언제든지 개인정보 처리의 정지를 요청할 수 있으며, 법률에 특별한 규정이 있는 등의 경우에는 “회사”는 처리정지 요청을 거부할 수 있습니다.<br><br> 
        (3) “회원”이 개인정보의 오류에 대한 정정을 요청한 경우, “회사”는 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 합니다.<br><br>
        (4) “회사”는 “회원”의 요청에 의해 해지 또는 삭제된 개인정보를 제3조에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리합니다.<br>

        <br>

        <strong style="font-size:15px;">제7조 수집한 개인정보의 제3자 제공</strong><br><br>
        “회사”는 “회원”의 개인정보를 제1조에서 고지한 범위 내에서 사용하며, “회원”의 사전 동의 없이는 동의 범위를 초과하여 이용하거나 원칙적으로 “회원”의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br><br> 

        • “회원”이 사전에 제3자 제공에 동의한 경우<br>
        • 서비스 제공에 따른 요금 정산을 위하여 필요한 경우<br>
        • 법령의 규정에 의하거나, 수사•조사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 및 감독당국의 요구가 있는 경우<br>
        • 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우<br>

        <br>

        <strong style="font-size:15px;">제8조 개인정보의 안전성 확보 조치</strong><br><br>
        “회사”는 개인정보 보호법에 따라 다음과 같이 안전성 확보에 필요한 기술적•관리적 및 물리적 조치를 하고 있습니다.<br><br>
        (1) 정기적인 자체 감사 실시<br>
        개인정보 취급 관련 안정성 확보를 위해 정기적으로 자체 감사를 실시하고 있습니다.<br><br>
        (2) 개인정보 취급 직원의 최소화 및 교육<br>
        개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.<br><br>
        (3) 내부관리계획의 수립 및 시행<br>
        개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.<br><br>
        (4) 해킹 등에 대비한 기술적 대책<br>
        “회사”는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신•점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적 • 물리적으로 감시 및 차단하고 있습니다.<br><br>
        (5) 개인정보의 암호화<br>
        “회원”의 개인정보는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.<br><br>
        (6) 접속기록의 보관 및 위변조 방지<br>
        개인정보처리시스템에 접속한 기록을 관계법령에서 요구하는 기간동안 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.<br><br>
        (7) 개인정보처리시스템 접근 제한<br>
        개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.<br><br>
        (8) 문서보안을 위한 잠금장치 사용<br>
        개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.<br><br>
        (9) 비인가자에 대한 출입 통제<br>
        개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.<br>

        <br>

        <strong style="font-size:15px;">제9조 개인정보 보호 업무 관련 담당부서 및 개인정보 보호책임자</strong><br><br>
        “회사”는 “회원”의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 개인정보 보호책임자를 지정하고 있습니다. “회원”은 “회사”의 서비스를 이용할때 발생하는 모든 개인정보 보호 관련 민원을 개인정보 관리책임자에게 신고할 수 있습니다. <br><br>
        <table class="Terms_table">
            <colgroup>
                <col width="40%">
                <col width="60%">
            </colgroup>
            <tbody>
                <tr>
                    <td>책임자 성명</td>
                    <td>백주현</td>
                </tr>
                <tr>
                    <td>연락처</td>
                    <td>02-6233-8900</td>
                </tr>
                <tr>
                    <td>이메일</td>
                    <td>juhyun.baik@workscombine.com</td>
                </tr>
            </tbody>
        </table><br><br>
        기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에 문의 가능합니다.<br>
        • 개인정보침해신고센터(https://privacy.kisa.or.kr / 국번없이 118)<br>
        • 대검찰청 사이버수사과(https://www.spo.go.kr / 국번없이 1301)<br>
        • 경찰청 사이버안전국(https://cyberbureau.police.go.kr / 국번없이 182)<br>

        <br>

        <strong style="font-size:15px;">제10조 개인정보처리방침의 개정 및 고지</strong><br><br>
        본 개인정보처리방침 개정 시 고지는 “서비스”를 통하거나 “회원”이 제공한 전자우편주소, (휴대)전화번호, 주소 등을 활용할 수 있습니다. 단, 제공, 위탁 또는 국외이전에 대한 변경의 경우는 고지 즉시 개정될 것입니다.<br><br>
        • 공고일자 : 2021년 10월 1일<br>
        • 시행일자 : 2021년 10월 1일
    </div>
</section>
</template>

<script>
    export default {
        name:'NoticeInfo',
        created () {
            this.$store.state.headerTitle = '개인정보 처리 방침';
            this.$store.commit('SHOW_ONLOAD');
        },
    }
</script>

<style lang="scss" scoped>

</style>